export function CrossIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        d="M12.7035 12.0036L17.8475 6.8597C18.046 6.66796 18.0515 6.3516 17.8597 6.15307C17.668 5.95453 17.3516 5.94903 17.1531 6.14077C17.149 6.14478 17.1449 6.14888 17.1408 6.15307L11.9969 11.297L6.85297 6.15304C6.65443 5.9613 6.33807 5.9668 6.14633 6.16534C5.95928 6.35901 5.95928 6.66603 6.14633 6.8597L11.2902 12.0036L6.14633 17.1475C5.95122 17.3427 5.95122 17.659 6.14633 17.8542C6.34147 18.0492 6.65783 18.0492 6.85297 17.8542L11.9969 12.7102L17.1408 17.8542C17.3393 18.0459 17.6557 18.0404 17.8474 17.8419C18.0344 17.6482 18.0344 17.3412 17.8474 17.1475L12.7035 12.0036Z"
        fill="currentColor"
      />
    </svg>
  );
}
